import { Component } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
	selector: 'plaintext-input',
	template: `<div [class]="to?.class || 'plaintext-field'">
		<label>{{ to.label }}</label>
		<p>{{ value }}</p>
	</div>`,
	standalone: true,
})
export class PlainTextInputComponent extends FieldType<FormlyFieldConfig> {}
